import { makeSuggestion } from 'api/suggestShipping';
import SidebarContext from 'state/SidebarContext';
import { useContext } from 'react';
import { ContentStateTypes, NotOptedInTypeMain, SuggestShippingType } from 'types/uiTypes';
import ConfirmationModal from './ConfirmationModal';

type ContentProps = {
    uiText: SuggestShippingType;
    setState: (state: ContentStateTypes) => void;
    setUiResponse: (response: NotOptedInTypeMain) => void;
};

const MakeSuggestion = ({ uiText, setState, setUiResponse }: ContentProps) => {
    const { title, text } = uiText;
    const { finnkode } = useContext(SidebarContext);

    const fetchData = async () => {
        setState('loading');
        await makeSuggestion(finnkode)
            .then((res) => {
                if (res) {
                    setUiResponse(res);
                    setState('content');
                } else {
                    setState('error');
                }
            })
            .catch(() => setState('error'));
    };

    return (
        <>
            <h4>{title}</h4>
            <p>{text}</p>
            <ConfirmationModal uiText={uiText} handleRequest={fetchData} />
        </>
    );
};

export default MakeSuggestion;
